import * as React from 'react';
// @ts-expect-error
import {Controller} from 'react-hook-form';
// @ts-expect-error
import type {Control, Watch} from 'react-hook-form';

import {Button} from 'shells/button/button';
import {FileImageIcon} from 'shells/icon/svg/file-image-icon';

import {handleFileUpload} from '../../../../helpers';

import styles from './field-styles.module.css';

type Props = {
    name: string;
    watch: Watch;
    isActive: boolean;
    control: Control;
};

export function ImageField(props: Props) {
    const imageUrl = props.watch(`${props.name}.imageUrl`);
    const width = props.watch(`${props.name}.width`);
    const justifyContent = props.watch(`${props.name}.justifyContent`);
    const id = props.watch(`${props.name}.id`);
    const fontSize = props.watch('inputStyle.fontSize');

    return (
        <Controller
            name={`${props.name}.imageUrl`}
            control={props.control}
            // @ts-expect-error
            render={({field}) => (
                <>
                    {imageUrl ? (
                        <div style={{justifyContent}} className={styles['image-field-container']}>
                            <img
                                src={imageUrl}
                                style={{width: `${width}%`}}
                                className={styles['image-styles']}
                            />
                            <div className={styles['image-field-overlay']}>
                                <Button
                                    variant='primary'
                                    onClick={() => handleFileUpload(field, id)}
                                    size='big'
                                >
                                    Change image
                                </Button>
                            </div>
                        </div>
                    ) : (
                        <div className={styles.upload}>
                            <FileImageIcon size={fontSize + 16} className={styles.icon} />
                            {props.isActive ? (
                                <Button
                                    variant='primary'
                                    size='big'
                                    onClick={() => handleFileUpload(field, id)}
                                >
                                    Upload an image
                                </Button>
                            ) : undefined}
                        </div>
                    )}
                </>
            )}
        />
    );
}
